import { color } from '@upstox/upstox-ui';

export const wrapper: CSSFunction = ({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 99,
  backgroundColor: color(theme, 'ui7'),
  height: '100%',
  fontFamily: theme.fonts.body,
});

export const innerCard: CSSFunction<{ currentTheme: ThemeKeys }> = ({
  theme,
  cssProps,
}) => {
  const { currentTheme } = cssProps;
  const borderColor =
    currentTheme === 'dark'
      ? color(theme, 'background.default3')
      : color(theme, 'ui1');

  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    border: `solid 2px ${borderColor}`,
    borderRadius: 16,
    maxWidth: 689,

    '@media screen and (max-width:768px)': {
      margin: '10px',
    },
  };
};

export const topContainer: CSSFunction = () => ({
  width: '100%',
  padding: '40px 32px 0px',
  textAlign: 'center',

  '@media screen and (max-width:768px)': {
    padding: '4px 0px',
  },
});

export const headerText: CSSFunction<{
  isBold?: boolean;
  currentTheme: ThemeKeys;
}> = ({ cssProps, theme }) => {
  const { isBold = false, currentTheme = 'light' } = cssProps;
  const fontWeight = isBold ? 'bold' : 'normal';
  const textColor =
    currentTheme === 'dark' ? color(theme, 'text.3') : color(theme, 'text.1');
  return {
    fontSize: 32,
    fontWeight: theme.fontWeights[fontWeight],
    color: textColor,
    textAlign: 'center',
    lineHeight: theme.lineHeights.m,
  };
};

export const subHeaderTextContainer: CSSFunction = () => ({
  marginTop: 16,
  marginBottom: 48,
  padding: '0 16px',

  '@media screen and (max-width:768px)': {
    marginBottom: 12,
  },
});

export const subHeaderText: CSSFunction = ({ theme }) => ({
  fontSize: 20,
  fontWeight: theme.fontWeights.normal,
  color: color(theme, 'text.2'),
  textAlign: 'center',
  lineHeight: '150%',
});

export const warningText: CSSFunction<{ currentTheme: ThemeKeys }> = ({
  theme,
  cssProps,
}) => {
  const { currentTheme = 'light' } = cssProps;
  const textColor =
    currentTheme === 'dark' ? color(theme, 'text.3') : color(theme, 'text.2');
  return {
    fontSize: 16,
    fontWeight: theme.fontWeights.normal,
    color: textColor,
    lineHeight: '150%',
  };
};

export const bottomContainer: CSSFunction<{ currentTheme: ThemeKeys }> = ({
  cssProps,
  theme,
}) => {
  const { currentTheme = 'light' } = cssProps;
  const bgColor =
    currentTheme === 'dark'
      ? color(theme, 'background.default3')
      : color(theme, 'ui1');
  return {
    width: '100%',
    backgroundColor: bgColor,
    padding: '40px 32px',
    textAlign: 'center',
    alignItems: 'center',

    '@media screen and (max-width:768px)': {
      padding: '4px 8px',
    },
  };
};

export const buttonContainer: CSSFunction<{ currentTheme: ThemeKeys }> = ({
  cssProps,
  theme,
}) => {
  const { currentTheme = 'light' } = cssProps;
  const bgColor =
    currentTheme === 'dark'
      ? color(theme, 'background.default3')
      : color(theme, 'background.default');
  return {
    width: '100%',
    maxWidth: 360,
    gap: 16,
    padding: '24px 16px 0',

    '@media screen and (max-width:768px)': {
      padding: '24px 8px 0',
    },

    '& button': {
      padding: 0,
    },

    '& button:first-child': {
      background: `${bgColor} !important`,
    },
  };
};

export const rememberCheckBox: CSSFunction<{ currentTheme: ThemeKeys }> = ({
  theme,
  cssProps,
}) => {
  const { currentTheme = 'light' } = cssProps;
  const iconColor = `${
    currentTheme === 'dark' ? color(theme, 'text.1') : color(theme, 'text.2')
  } !important`;
  return {
    marginTop: 26,
    gap: 11,

    '& .checkboxIcon': {
      height: '18px !important',
      width: '18px !important',
    },

    '& input': {
      right: 0,
    },
    '& svg': {
      right: 0,
      color: iconColor,
    },
  };
};

export const rememberCheckBoxText: CSSFunction<{ currentTheme: ThemeKeys }> = ({
  cssProps,
  theme,
}) => {
  const { currentTheme = 'light' } = cssProps;
  const textColor =
    currentTheme === 'dark' ? color(theme, 'text.1') : color(theme, 'text.2');
  return {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '20px',
    color: textColor,
  };
};
